import { consentUpdate, defaultPageView, scroll, onsiteSearch, defaultLinkClick } from './tracking-events';
import { TrackingData, TrackingEvent, ConsentUpdateEvent } from './types';

let lastConsentUpdate: ConsentUpdateEvent | null = null;

const trackingFunctions = {
  defaultPageView,
  consentUpdate,
  scroll,
  onsiteSearch,
  defaultLinkClick,
};

const trackingBaseType = (type: string) => (data: TrackingData) => {
  const trackingFunction = trackingFunctions[type];

  if (!trackingFunction) {
    // eslint-disable-next-line no-console
    console.warn(`Tracking function for event type "${type}" not found`);

    return {
      event: type,
    };
  }

  return {
    event: type,
    ...trackingFunction(data),
  };
};

export const AdobeTracking = (data: TrackingData, type: string) => {
  AdobeTrackingService.push(trackingBaseType(type)(data));
};

export const AdobeTrackingService = {
  push(item: TrackingEvent): void {
    if (shouldPushConsentUpdate(item)) {
      window.oneDataLayer = window.oneDataLayer || [];
      window.oneDataLayer.push({ ...item });
    }
  },
};

function isConsentUpdateEvent(event: TrackingEvent): event is ConsentUpdateEvent {
  return event.event === 'consentUpdate';
}

function shouldPushConsentUpdate(newItem: TrackingEvent): boolean {
  if (!isConsentUpdateEvent(newItem)) {
    return true;
  }

  if (lastConsentUpdate && JSON.stringify(lastConsentUpdate.user.consent) === JSON.stringify(newItem.user.consent)) {
    return false;
  }

  lastConsentUpdate = { ...newItem };
  return true;
}
